import { Navigate, useLocation } from 'react-router-dom'
import travelAgentService from '../services/travelAgentService'

const ProtectedRoute = ({ children }) => {
  const location = useLocation()

  if (!travelAgentService.isAuthenticated()) {
    return <Navigate to="/login" replace />
  }

  // Force the password reset flow for admin-created accounts, but avoid an
  // infinite redirect when we are already on that page.
  if (
    travelAgentService.mustChangePassword() &&
    location.pathname !== '/change-password-required'
  ) {
    return <Navigate to="/change-password-required" replace />
  }

  return children
}

export default ProtectedRoute
